import useResourceHints from '../hooks/useResourceHints';

const withIntegrationHooksWrapper = <P extends {}>(url?: string) => (
  Component: React.ComponentType<P>
) => (props: P) => {
  useResourceHints({ href: url });
  return <Component {...props} />;
};

export default withIntegrationHooksWrapper;
